async function calculateShippingCost() {
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/shipping_rates.json?shipping_address%5Bzip%5D=69000&shipping_address%5Bcountry%5D=France', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        const data = await response.json();

        if (data && data.shipping_rates && data.shipping_rates.length > 0) {
            let estimatedShippingCost = data.shipping_rates[0].price;
            let resp =  estimatedShippingCost > 0 ? ' £'+ estimatedShippingCost : 'Free';
            return resp;
        } else {
            return 'Calcul impossible';
        }
    } catch (error) {
        console.error('Erreur lors de la récupération des frais de livraison : ' + error);
        return 'Erreur';
    }
}

async function updateShippingCost() {
    try {
        const estimatedShippingCost = await calculateShippingCost();
        const shippingCostElement = document.querySelector('#shipping-cost');
        setTimeout(() => {
            if(shippingCostElement) shippingCostElement.innerHTML = estimatedShippingCost;
        }, 1000);
    } catch (error) {
        console.error('Erreur lors de la mise à jour des frais de livraison : ' + error);
    }
}

updateShippingCost();

document.addEventListener('cartUpdated', updateShippingCost);